// extracted by mini-css-extract-plugin
export var embla = "workimages-module--embla--kcOyA";
export var emblaThumb = "workimages-module--embla--thumb--1-4p1";
export var embla__container = "workimages-module--embla__container--2AN3f";
export var embla__containerThumb = "workimages-module--embla__container--thumb--1na64";
export var embla__slide = "workimages-module--embla__slide--1Mnj0";
export var embla__slideThumb = "workimages-module--embla__slide--thumb--3-2VA";
export var embla__slide__img = "workimages-module--embla__slide__img--1NnGk";
export var embla__slide__inner = "workimages-module--embla__slide__inner--32qlr";
export var embla__slide__innerThumb = "workimages-module--embla__slide__inner--thumb--1lB8X";
export var embla__slide__thumbnail = "workimages-module--embla__slide__thumbnail--31ss9";
export var embla__thumbs = "workimages-module--embla__thumbs--1zRl-";
export var embla__viewport = "workimages-module--embla__viewport--1N5OF";
export var isDraggable = "workimages-module--is-draggable--2Dic9";
export var isDragging = "workimages-module--is-dragging--2xTYa";
export var isSelected = "workimages-module--is-selected--2_OJm";